<template>
  <div class="body">
    <vue-office-docx
      v-if="type == '.doc' || type == '.docx'"
      :src="docxUrl"
      style="height: 100vh;"
      @rendered="renderedHandler"
      @error="errorHandler"
    />
    <!-- || type == '.et' -->
    <vue-office-excel
      v-else-if="type == '.xlsx' || type == '.xls'"
      :src="docxUrl"
      style="height: 100vh;"
      @rendered="renderedHandler"
      @error="errorHandler"
    />
    <vue-office-pdf
      v-else-if="type == '.pdf'"
      :src="docxUrl"
      @rendered="renderedHandler"
      @error="errorHandler"
    />
    <iframe
      v-else
      :src="docxUrl"
      frameborder="0"
      width="100%"
      height="100%"
    ></iframe>
  </div>
</template>
<script>
//引入VueOfficeDocx组件
import VueOfficeDocx from "@vue-office/docx";
//引入相关样式
import "@vue-office/docx/lib/index.css";
//引入VueOfficeExcel组件
import VueOfficeExcel from "@vue-office/excel";
//引入相关样式
import "@vue-office/excel/lib/index.css";
//引入VueOfficePdf组件
import VueOfficePdf from "@vue-office/pdf";
export default {
  name: "PreviewFile",
  components: { VueOfficeDocx, VueOfficeExcel, VueOfficePdf },
  props: [],
  data() {
    return {
      docxUrl: null,
      type: null
    };
  },
  created() {},
  computed: {},
  mounted() {
    this.docxUrl = this.$route.params.filesUrl;
    console.log(this.docxUrl);
    this.type = this.$route.params.type;
  },
  methods: {
    renderedHandler() {
      console.log("渲染完成");
    },
    errorHandler(e){
      console.log('失败',e);
    }
  },
  beforeDestroy() {}
};
</script>
<style scoped>
.body {
  width: 100%;
  height: 100vh;
}
@media (min-width: 768px) {
}
</style>



// WEBPACK FOOTER //
// src/view/hipc/PreviewFile.vue